import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';

class MasqueradeRoute extends Route {
  @service auth;
  @service router;

  activate(transition) {
    super.activate(...arguments);
    this.masquerade.perform(transition.to.params.id);
  }

  @restartableTask()
  *masquerade(id) {
    try {
      yield this.auth.masquerade.perform(id);
    } catch {
      this.router.replaceWith('access-denied');
    }
  }
}

export default MasqueradeRoute;
